<template>
  <div class="drop-down" :class="rootClasses">
    <button class="drop-down__toggle" @click="toggleVisibility">
      <slot>
        {{ selectedItem }}
      </slot>
      <icon-caret-down />
    </button>
    <ul class="drop-down__options-list" v-if="isOpen">
      <li v-for="option in availableOptions" :key="option.id">
        <button class="drop-down__option-button" :class="itemClasses(option)" @click="selectOption(option)">
          {{ option.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import IconCaretDown from '~/assets/icons/IconCaretDown.svg';
import { startListening, stopListening } from "~/common/ts/clickAway";

export default {
  components: {
    IconCaretDown,
  },
  props: {
    selectedItem: [Object, String],
    availableOptions: Array,
    showRight: Boolean,
  },
  data () {
    return {
      isOpen: false,
    };
  },
  computed: {
    rootClasses () {
      return {
        'drop-down--left': !this.showRight,
        'drop-down--right': this.showRight,
      };
    },
  },
  methods: {
    toggleVisibility () {
      if (this.isOpen) {
        this.closeVisibility();
      } else {
        this.isOpen = true;
        startListening(this.$el, this.closeVisibility);
      }
    },
    closeVisibility () {
      this.isOpen = false;
      stopListening(this.$el, this.closeVisibility);
    },
    selectOption (option) {
      this.$emit('on-select', option.id);
      this.closeVisibility();
    },
    itemClasses (option) {
      return {
        'drop-down__option-button--selected': option.id === this.selectedItem,
      };
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/helpers";
@use "~/common/scss/variables";

.drop-down {
  $root: &;

  position: relative;

  &__toggle {
    align-items: center;
    display: flex;
    gap: .25rem;
    white-space: nowrap;
    color: #000;
  }

  &__options-list {
    background-color: #FFF;
    display: flex;
    flex-flow: column;
    list-style: none;
    padding: 0 0;
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 10;

    #{$root}--left & {
      left: 0;
      text-align: left;
    }

    #{$root}--right & {
      right: 0;
      text-align: right;
    }
  }

  &__option-button {
    display: flex;
    padding: .15rem .5rem;
    transition: background-color .25s;
    width: 100%;
    color: #000;

    &:hover {
      background-color: variables.$colorGreyActive;
    }

    #{$root}--left & {
      justify-content: start;
      text-align: left;
    }

    #{$root}--right & {
      justify-content: end;
      text-align: right;
    }

    &--selected {
      color: var(--color-orange);
    }
  }
}
</style>
